import React, { createContext, useContext, useMemo, type ReactNode } from 'react';
import { getUserTheme, type Theme, type UserType } from '../../shared/styles/theme/theme';

interface ThemeContextValue {
  userType: UserType;
  theme: Theme;
}

const defaultThemeContext: ThemeContextValue = {
  userType: 'traveller', // Default to traveller
  theme: getUserTheme('traveller'), 
};

const ThemeContext = createContext<ThemeContextValue>(defaultThemeContext);

interface ThemeProviderProps {
  children: ReactNode;
  userType: UserType;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ 
  children, 
  userType 
}) => {
  const theme = useMemo(() => getUserTheme(userType), [userType]);

  const value = useMemo<ThemeContextValue>(
    () => ({ userType, theme }),
    [userType, theme]
  );

  return (
    <ThemeContext.Provider value={value}>
      <div 
        className={`theme-${userType}`} 
        data-theme={userType}
      >
        {children}
      </div>
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};